<template>
  <div class="container container-fluid">
    <div class="row">
      <div>
        <GoogleMap :api-key="keyGoogle" style="width: 100%; height: 300px" :center="center" :zoom="15">
          <CustomMarker :options="{ position: center }" />
        </GoogleMap>

        <div class="col-md-12 mt-3">
          <!-- <div class="btn tbn-block btn-custom" @click="showLocationPrompt">
            Obtener Ubicación
          </div> -->
          <div class="col-md-12 mt-3">
            <label class="form-label text-left" for="locationInput">Ubicación:</label>
            <input v-if="selectedLocation" type="text" class="form-control" disabled v-model="selectedLocation">
            <!-- <Vue-select
              class="custom-vue-select"
              disabeld
              v-model="selectedLocation"
              :options="filteredLocations"
              label="label"
              placeholder="Selecciona una ubicación..."
              @search="handleSearch"
              @change="handleLocationChange"
            >
            <template v-slot:no-options="{ data, searching }">
              <template v-if="searching">
                <em style="opacity: 0.5">No se encontraron resultados {{ data }}</em>
              </template>
              <em v-else style="opacity: 0.5">No se encuentraron resultados</em>
            </template>
            </Vue-select> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { ref, onMounted, watchEffect, defineComponent } from "vue";
import Swal from "sweetalert2";
import { GoogleMap, Marker as CustomMarker } from "vue3-google-map";

export default defineComponent({
  name: 'FormMap',
  components: { GoogleMap, CustomMarker },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const center = ref({ lat: 0, lng: 0 });
    const keyGoogle = process.env.VUE_APP_GOOGLE_MAPS_API_KEY || "";
    const locations = ref([]);
    const selectedLocation = ref(null);
    const filteredLocations = ref([]);
    const autoUpdateLocation = ref(false);

    const formData = ref({
      gpsLatitude: null,
      gpsLongitude: null,
      gpsGeolocationData: null,
    });

    const updateCenterWithCurrentLocation = async () => {
      if (navigator.geolocation) {
        try {
          const position = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject);
          });
          center.value = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          emitFieldChanged();
          await updateManualInput(position.coords.latitude, position.coords.longitude);
          autoUpdateLocation.value = true;
        } catch (error) {
          console.error("Error al obtener la ubicación actual:", error);
        }
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    };

    const updateManualInput = async (lat, lng) => {
      try {
        const response = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${keyGoogle}`
        );
        const data = await response.json();

        if (data.status === "OK" && data.results.length > 0) {
          selectedLocation.value = data.results[0].formatted_address;
          emitFieldChanged();
        } else {
          console.error("Error al obtener la dirección actual");
        }
      } catch (error) {
        console.error("Error al obtener la dirección actual:", error);
      }
    };

    const useCurrentLocation = () => {
      updateCenterWithCurrentLocation();
    };

    const handleSearch = async searchTerm => {
      if (searchTerm.trim() !== "") {
        try {
          const response = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(searchTerm)}&key=${keyGoogle}`
          );
          const data = await response.json();
          if (data.status === "OK" && data.results.length > 0) {
            locations.value = data.results;
          } else {
            console.error("Error: No se encontraron resultados");
          }
        } catch (error) {
          console.error("Error al realizar la búsqueda de ubicación:", error);
        }
      } else {
        locations.value = [];
      }
    };

    const handleLocationChange = (newValue) => {
      const selected = filteredLocations.value.find(loc => loc.value === newValue);
      if (selected) {
        const locationData = locations.value.find(loc => loc.place_id === newValue);
        if (locationData) {
          const { lat, lng } = locationData.geometry.location;
          center.value = { lat, lng };
        } else {
          console.error("No se encontraron datos de ubicación para la selección:", selected);
        }
      } else {
        console.error("No se encontró la ubicación seleccionada en las ubicaciones filtradas:", newValue);
      }
    };

    const showLocationPrompt = () => {
      Swal.fire({
        title: "¿Usar ubicación actual?",
        text: "Selecciona una opción",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí, usar ubicación actual",
        cancelButtonText: "No, ingresar manualmente",
      }).then((result) => {
        if (result.isConfirmed) {
          updateCenterWithCurrentLocation();
        }
      });
    };

    const emitFieldChanged = () => {
      formData.value.gpsLatitude = center.value.lat;
      formData.value.gpsLongitude = center.value.lng;
      formData.value.gpsGeolocationData = selectedLocation.value;
      emit('formDataChanged', formData.value);
    };

    onMounted(() => {
      autoUpdateLocation.value = true;
      updateCenterWithCurrentLocation();
    });

    watchEffect(() => {
      filteredLocations.value = locations.value.map(location => {
        const labelKey = Object.keys(location).find(key => key.includes('formatted_address'));
        return {
          value: location.place_id,
          label: labelKey ? location[labelKey] : 'Ubicación Desconocida'
        };
      });
    })

    return {
      center,
      keyGoogle,
      selectedLocation,
      filteredLocations,
      autoUpdateLocation,
      useCurrentLocation,
      handleSearch,
      handleLocationChange,
      showLocationPrompt,
      emitFieldChanged,
      formData,
    };
  },
});
</script>
